import {
  compose,
  withProps,
} from 'recompose';

const setTitle = ({ title, storeName, label, t }) => {
  const countryName = storeName.slice(10);
  const isIndexRoute = label === '';
  const messageKey = 'navbar.meta_title' + (isIndexRoute ? '' : '_') + label.replace(/\s+/g, '').toLowerCase();
  let defaultTitle = title ? `${storeName} - ${title}` : storeName;
  if (label === 'Photobook Pass') {
    defaultTitle = `Photobook Pass ${countryName} - ${title}`;
  }
  const fullTitle = `${t(messageKey, defaultTitle, { 'storeName': storeName, 'countryName': countryName })}`;
  document.title = fullTitle;
};

export const withSetTitle = compose(
  withProps(({ callbacks = [] }) => ({
    callbacks: [...callbacks, setTitle]
  }))
);

export const withTitle = compose(
  withSetTitle,
);



// WEBPACK FOOTER //
// ./src/Common/Helmet/WithTitle.js